import React from "react";

const MyLoader = (props) => {
    return (
        <div className="w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50">
            <span className="opacity-100 top-1/2 my-0 mx-auto block relative w-0 h-0" style={{color:'#521c3e',top: '50%'}}>
                <i className="fas fa-circle-notch fa-spin fa-5x"/>
            </span>
        </div>
    );
}

export default MyLoader;
